import React, { useContext } from 'react'
import ChargeModification from "./ChargeModification";
import { RolePermissions, PermissionContext } from "appContext";
import { PermisionDenied } from "../../../common/commonComponents";
import { pages } from "../../../common/constant"
import ChargeModiBUPanIndiaConfig from './ChargeModiBUPanIndiaConfig';

const ChargeModiConfigSetup = () => {
  const userPermissions = RolePermissions(useContext(PermissionContext),pages["chargeModiConfig"]["id"]);

  return userPermissions ? <ChargeModiBUPanIndiaConfig /> : <PermisionDenied />;
};
export default ChargeModiConfigSetup;
